import type * as React from 'react';
import { patch } from '@Domain/Api';
import documentTemplateVersionSectionsUpdated, {
	type DocumentTemplateVersionSectionsUpdatedAction,
	type DocumentTemplateVersionSectionsUpdatedPayload,
} from '@Application/Documents/Templates/Actions/documentTemplateVersionSectionsUpdated';
import documentTemplateVersionSectionsUpdateFailed, {
	type DocumentTemplateVersionSectionsUpdateFailedAction,
} from '@Application/Documents/Templates/Actions/documentTemplateVersionSectionsUpdateFailed';
import type UpdateDocumentTemplateVersionSections from '@Application/Documents/Templates/Commands/UpdateDocumentTemplateVersionSections';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions =
	| DocumentTemplateVersionSectionsUpdatedAction
	| DocumentTemplateVersionSectionsUpdateFailedAction;

export default (command: UpdateDocumentTemplateVersionSections) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await patch<DocumentTemplateVersionSectionsUpdatedPayload>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/document-template-versions/${command.versionId}`,
				command.toJSON(),
			);

			const action = documentTemplateVersionSectionsUpdated(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentTemplateVersionSectionsUpdateFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
